<template>
  <div class="content">
    <LoginView redirect-to="/perfil"></LoginView>
  </div>
</template>

<script>
import LoginView from "./LoginView.vue";
export default {
  components: {
    LoginView,
  }
};
</script>
<style scoped>
.content {
  display: flex;
  justify-content: center;
  height: 100vh; 
  text-align: center;
}
</style>
